<div class="coach-component content">
    <div class="coach-head">
        <ion-label>{{'__COACHING_JOURNEY_COACHES_LIST_CONTENT__' | translate}}:</ion-label>
    </div>

    <div class="show-completed">
        <div class="notifications">
            <div class="text">{{'__COACHING_JOURNEY_COACHES_LIST_SHOW_ALL__' | translate}}</div>
            <ion-toggle class="black-toggle"
                        [checked]="isShowMatched"
                        (ionChange)="isShowMatched = !isShowMatched"
                        [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                        [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                        mode="ios"></ion-toggle>
        </div>
    </div>

    <div class="inner-container" *ngIf="coachesList">
        <ng-container *ngFor="let coach of coachesList | filter : 'matched' : true : isShowMatched ? 'ignore' : 'equals';">
            <div class="profile-box-wrap">
                <div class="coach-calendar">
                    <button (click)="gotoCalendar(coach.id)">
                        <app-inline-svg [cssClass]="'img'" [file]="'assets/img/coach-calendar-main.svg'" ></app-inline-svg>
                    </button>
                </div>
                <div class="white-group" (click)="gotoProfile(coach.id)">
                    <div class="empty-container"></div>
                    <div class="coach-profile-photo">
                        <app-inline-svg class="img" *ngIf="coach.file === null" [file]="'assets/img/user-blue.svg'" ></app-inline-svg>
                        <img *ngIf="coach.file !== null" [src]="coach.file.url" />
                    </div>
                    <div class="coach-name">{{coach.full_name}}</div>
                    <div class="coach-speciality my-color-blue">
                        {{coach.job_title}}
                    </div>
                </div>
                <div class="statistics">
                    <div class="statistic-el"><img class="icon-l" src="assets/icon/speak.svg" alt="">{{coach.progress_languages.completed}}/{{coach.progress_languages.total}}</div>
                    <div class="statistic-el"><img class="icon-l" src="assets/icon/location.svg" alt="">{{coach.progress_locations.completed}}/{{coach.progress_locations.total}}</div>
                    <div class="statistic-el"><img class="icon-l icon-xl" src="assets/icon/competencies.svg" alt="">{{coach.progress_competencies.completed}}/{{coach.progress_competencies.total}}</div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="inner-container" *ngIf="!coachesList">
        <ng-container *ngFor="let coach of [1,2,3,4]">
            <div class="white-group" style="height: 13rem">
                <div class="coach-calendar"><ion-skeleton-text animated></ion-skeleton-text></div>
                <div class="coach-profile-photo"><ion-skeleton-text animated></ion-skeleton-text></div>
                <div class="coach-name">
                    <ion-skeleton-text animated style="width: 10rem; height: 1.3rem"></ion-skeleton-text>
                </div>
                <div class="coach-speciality">
                    <ion-skeleton-text animated style="height: 0.7rem"></ion-skeleton-text>
                </div>
            </div>
        </ng-container>
    </div>
</div>
